import { setActionPrices } from '@0xtorch/core'
import type { CexData, CreateCexDataParameters } from '../types'

export const createCexData = async <T>({
  apiKey,
  apiSecret,
  password,
  from,
  to,
  limit,
  desc,
  proxy,
  proxyHeaders,
  accountId,
  cryptoCurrencies,
  fiatCurrencies,
  fiat,
  cryptoCurrencyDataSource,
  fetchAllData,
  parseToActions,
  parseToAccountIds,
  parseToSources,
}: CreateCexDataParameters<T>): Promise<CexData> => {
  const {
    data,
    from: fetchedFrom,
    to: fetchedTo,
  } = await fetchAllData({
    apiKey,
    apiSecret,
    password,
    from,
    to,
    proxy,
    headers: proxyHeaders,
  })
  const actions = parseToActions({
    data,
    accountId,
    cryptoCurrencies,
    fiatCurrencies,
  })
  const pricedActions = await setActionPrices({
    actions,
    fiat,
    dataSource: cryptoCurrencyDataSource,
  })
  const accountIds = parseToAccountIds(data)
  const sources = parseToSources(data)
  return {
    actions: pricedActions,
    accountIds,
    sources,
    limit,
    desc,
    from: fetchedFrom,
    to: fetchedTo,
  }
}
